import { render, staticRenderFns } from "./DotCmsMenu.vue?vue&type=template&id=53fcf4e6&"
import script from "./DotCmsMenu.vue?vue&type=script&lang=js&"
export * from "./DotCmsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports